import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const PersonalGreenWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default PersonalGreenWorkReport
